export default __webpack_public_path__ + "images/74d98431c40b2d798e64b1d9a917248b-environmentsustainability.jpg";